import Cookie from 'js-cookie';
import axios from 'axios';
// import { Env } from '@stencil/core';

async function fetchChannels(env) {

	const BTSESSION = Cookie.get("BTSESSION");

	const channelApi = `${env}/service/channel/v2/my/channels?pageSize=25`;

	if (BTSESSION && typeof BTSESSION != 'undefined') {
		try {
			const response = await axios.get(
				channelApi,
			{
				headers: {
					'Accept': 'application/json',
					'Cookie': 'BTSESSION=' + BTSESSION,
					'X-BrightTALK-access': 'niHeeF1ao2',
					'Content-Type': 'application/json',
					'BrightTALK-API-Client': 'wordpress'
				},
				withCredentials: true
			}
			);
			// console.log("success");
			// console.log(response.data);
			return updateChannelState(response);
		} catch (error) {
			console.log("error");
			console.log(error);
		}
	}

}

export function updateChannelState(response){

	const data = response.data;

	let isChannelOwner = false
	if (data['channels'] !== undefined && data['channels'].length !== 0){
		isChannelOwner = true
	}

	if (data){
		return {
			isChannelOwner: isChannelOwner
		}
	}
}


export default fetchChannels